import { render } from "./EmployeeOrderDetailsComponent.vue?vue&type=template&id=82caacd4"
import script from "./EmployeeOrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeOrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/employees/EmployeeOrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82caacd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82caacd4', __exports__)) {
    api.reload('82caacd4', __exports__)
  }
  
  module.hot.accept("./EmployeeOrderDetailsComponent.vue?vue&type=template&id=82caacd4", () => {
    api.rerender('82caacd4', render)
  })

}


export default __exports__